import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class GlobalsService {

    private _username: string = '';
    private _userid: string = '';
    isAdmin: boolean;
    isSuperUser: boolean;

    constructor(private cookieService: CookieService) {}

    get username(): string { return this._username; }
    set username(value: string) { this._username = value; }

    get userid(): string { return this._userid; }
    set userid(value: string) { this._userid = value; }

    get cookieUsername(): string {
        const username = this.getLastAuthUser(environment.amplify.Auth.Cognito.userPoolClientId, 'LastAuthUser');
        return username?.replace(/@/g, '%40') ?? '';
    }

    private getLastAuthUser(userPoolClientId: string, key: string): string | undefined {
        const allCookies = this.cookieService.getAll();
        for (let cookie in allCookies) {
            if (cookie.includes(key) && cookie.includes(userPoolClientId)) {
                return allCookies[cookie];
            }
        }
    }
}